import { InlineWidget, useCalendlyEventListener } from "react-calendly";
import { observer, inject } from "mobx-react";
import { useEffect } from "react";

const { fetch: originalFetch } = window;
window.fetch = async (...args) => {
  let [resource, config] = args;

  let response = await originalFetch(resource, config);

  // response interceptor
  const json = () =>
    response
      .clone()
      .json()
      .then((data) => ({ ...data, title: `Intercepted: ${data.title}` }));

  response.json = json;
  return response;
};

const CalendlyWidget = ({ userStore, url, repairPage }) => {
  useEffect(() => {
    captureNetworkRequest();
  }, []);

  const captureNetworkRequest = () => {
    // var capture_network_request = [];
    var capture_resource = performance.getEntries();
    for (var i = 0; i < capture_resource.length; i++) {
      // if (capture_resource[i].name.includes("invitees")) {
      // if (capture_resource[i].name.indexOf("www.demo.com OR YOUR URL") > -1) {
      // capture_network_request.push(capture_resource[i].name);
      // }
    }
  };

  useCalendlyEventListener({
    onDateAndTimeSelected: (e) =>
      console.log(
        "onDateAndTimeSelected",
        console.log(
          "Script event data1:",
          e.data.event.start_time,
          e.data.payload.start_time
        )
      ),
    onEventTypeViewed: (e) =>
      console.log(
        "onEventTypeViewed",
        console.log(
          "Script event data2:",
          e.data.event.start_time,
          e.data.payload.start_time
        )
      ),
    onEventScheduled: (e) => {
      console.log(
        "Script event data3:",

        e.data.payload
      );

      onEventScheduled(e.data.payload, repairPage);
    },
  });

  const onEventScheduled = async (payload, repairPage) => {
    console.log("payload", payload);

    // const elements = document.querySelectorAll(".YAmKI90l5OyINFgGmq9L");
    // const elements = document.getElementsByTagName("iframe");
    window.onmessage = function (event) {
      console.log("ev-data", event);
      console.log("ev-data", event.target?.document);

      //const x = event.target?.document.getElementsByTagName("iframe");
      //   console.log("v", x);
      // console.log("jjj", x[0].contentWindow?.document);
    };
    // var iframe = document.getElementById("root");
    //  var elements = iframe.contentWindow.document.getElementsByTagName("div");

    // const inviteeSplit = payload?.invitee?.uri?.split("/");
    // const inviteeCode = inviteeSplit?.[inviteeSplit.length - 1];
    // const body = {
    //   MAINCUST: userStore.userDetails.MAINCUST,
    //   CUST: userStore.userDetails.CUST,
    //   MAINENV: userStore.userDetails.MAINENV,
    //   REPAIRNAME: repairPage.REPAIRNAME,

    //   data: {
    //     CALENDLY_INVITEE: inviteeCode,
    //   },
    // };
    ///calendly-inline-widget
    //  await repairPagesStore.updateRepairPage(body);
    //  class="YAmKI90l5OyINFgGmq9L TuKawS25ZXxJafgZdElP"
    //YAmKI90l5OyINFgGmq9L TuKawS25ZXxJafgZdElP
  };

  return (
    <div style={{ minWidth: "50vw", height: "80vh" }}>
      <InlineWidget url={url} />
    </div>
  );
};

export default inject(
  "userStore",
  "repairPagesStore"
)(observer(CalendlyWidget));
